import { MfaMethodsEnum } from './session';

export class LoginResponse {
  mfaMethods?: MfaMethodsEnum[];
  success?: boolean;
  dotrustprompt?: boolean;
  notRegistered?: any;
  phoneHint?: string;
}
